import { sendFacebooklink, sendKakaoLink } from '@common/share';
import { ShareDataType } from '@type/web/product';

import usePortal from '@hook/usePortal';

const useShare = (shareData: ShareDataType) => {
  const {
    PopUp: Toast,
    onShowPopUp: onShowToast,
    onHidePopUp: onHideToast,
  } = usePortal('toast');
  const sharedUrl = `${shareData.url}${
    shareData.url.indexOf('?') > -1 ? '&' : '?'
  }brsource=url`;
  const handleShareFacebook = () => {
    const { GA, facebook } = shareData;
    // sendGA({
    //   ...GA,
    //   event: 'ga_event',
    //   action: '공유하기',
    //   label: '페이스북공유하기',
    // });
    const shareUrl = `${facebook}${
      facebook.indexOf('?') > -1 ? '&' : '?'
    }brsource=facebook`;
    sendFacebooklink(shareUrl);
  };
  const handleShareKakao = () => {
    const { GA, kakao } = shareData;
    // sendGA({
    //   ...GA,
    //   event: 'ga_event',
    //   action: '공유하기',
    //   label: '카카오톡공유하기',
    // });
    const shareUrl = `${kakao.link}${
      kakao.link.indexOf('?') > -1 ? '&' : '?'
    }brsource=kakao`;
    sendKakaoLink({
      ...kakao,
      link: shareUrl,
    });
  };
  const handleCopyUrl = () => {
    const { GA } = shareData;
    // sendGA({
    //   ...GA,
    //   event: 'ga_event',
    //   action: '공유하기',
    //   label: 'URL공유하기',
    // });
    onShowToast();
    setTimeout(() => onHideToast(), 1000);
  };
  return {
    Toast,
    handleShareFacebook,
    handleShareKakao,
    handleCopyUrl,
    sharedUrl,
  };
};

export default useShare;
